var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.478 20.008c.086-.006.108-.005.194-.02a1.433 1.433 0 0 0 .768-.398l8.575-8.575c.06-.063.076-.078.129-.147a1.431 1.431 0 0 0 0-1.727c-.053-.07-.07-.084-.129-.147L2.44.419C2.377.359 2.362.343 2.293.29A1.434 1.434 0 0 0 .815.138a1.44 1.44 0 0 0-.808 1.145 1.434 1.434 0 0 0 .283 1.01c.053.069.07.083.129.147l7.564 7.564L.42 17.57l-.067.071c-.055.068-.07.083-.118.156a1.432 1.432 0 0 0-.233.832 1.433 1.433 0 0 0 1.186 1.36c.085.015.107.014.193.02h.098z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.0d4c3ec8ad96d7059a40cf91ee61f47e.svg";
export { ForwardRef as ReactComponent };